module.exports = __webpack_public_path__ + "static/media/b.24873dd0.svg";